
const OEClipboard = new class {

    fallbackCopyText(text)   {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
      
        let promise;

        try {
            document.execCommand('copy');
            promise = Promise.resolve();
        } catch(err) {
            console.log('Warning: OEClipboard::fallbackCopyText failed.');
            promise = Promise.reject(err);
        }
      
        document.body.removeChild(textArea);

        return promise;
    }

    copyText(text)   {
        if(!navigator.clipboard)    {
            return this.fallbackCopyText(text);
        }

        return navigator.clipboard.writeText(text).then(null, (err) => {
            console.log('Warning: OEClipboard::copyText failed.');
            return Promise.reject(err);
        });
    }
};

export default OEClipboard;